import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-dialog-popup',
  templateUrl: './dialog-modal.component.html',
  styleUrls: ['./dialog-modal.component.scss']
})
export class DialogModalComponent implements OnInit {

  @Input() modalTitle;
  @Input() noButton = true;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/dialog-modal/dialog-modal.component.ts